import React from 'react';
import './../Apps.css';
import DragDrop from './../DragDrop';

const Tableapp = ({name}) => {
    return (
        <DragDrop appName = {name} />
    );
};

export default Tableapp;